<div class="installation-dialog">
  <app-dialog-basic>
    <div class="installation-dialog-inner">
      <p class="installation-dialog-title">新規導入の申し込み</p>
      <div class="installation-dialog-buttons">
        <button mat-flat-button color="primary" class="installation-dialog-primary" (click)="onHighSchoolClick()">
          高校向けはこちら
        </button>
        <div class="installation-dialog-secondary" (click)="onCramSchoolClick()" role="button" tabindex="0">
          <app-link-with-arrow>塾・予備校の導入／その他ご相談はこちら</app-link-with-arrow>
        </div>
        <div class="installation-dialog-secondary" (click)="onUniversityClick()" role="button" tabindex="0">
          <app-link-with-arrow>大学の導入／その他ご相談はこちら</app-link-with-arrow>
        </div>
      </div>
    </div>
  </app-dialog-basic>
  <app-dialog-basic-footer>
    <button mat-stroked-button (click)="close()">閉じる</button>
  </app-dialog-basic-footer>
</div>
